import { AspectRatio, Image } from '@mantine/core'
import classes from './RowData.module.css'
import { getRankSuffix } from '../../helpers'
import { IconChevronRight } from '@tabler/icons-react'
import { Typography } from '../../typography'
import { useMediaQuery } from '@mantine/hooks'
import clsx from 'clsx'

export default function RowData({
  player_name,
  player_image,
  team_name,
  team_logo,
  score,
  rank,
}: {
  player_name?: string
  player_image?: string
  team_name?: string
  team_logo?: string
  score?: number
  rank?: number
}) {
  const isDesktop = useMediaQuery('(min-width: 800px)')

  return (
    <div className={classes.container}>
      <div className={classes.data}>
        {rank && (
          <Typography lh="140" className={classes.rank}>
            {rank}
            <sup>{getRankSuffix(rank)}</sup>
          </Typography>
        )}
        {player_image && (
          <Image
            src={player_image}
            alt={player_name}
            className={clsx(classes.playerImage, {
              [classes.playerImageDesktop]: isDesktop,
            })}
            fit="scale-down"
          />
        )}
        {team_logo && (
          <AspectRatio ratio={1 / 1}>
            <Image
              src={team_logo}
              alt={team_name}
              className={clsx(classes.teamLogo, {
                [classes.teamLogoDesktop]: isDesktop,
              })}
              fit="scale-down"
            />
          </AspectRatio>
        )}
        <Typography
          fs={player_name && player_image ? 'sm' : 'md'}
          lh={player_name && player_image ? '150' : '140'}
        >
          {player_name && player_image ? player_name : team_name}
        </Typography>
      </div>
      <div className={classes.data}>
        {score && (
          <Typography ff="JetBrains Mono" fw={500} lh="140">
            {score.toFixed(2)}
          </Typography>
        )}
        <IconChevronRight />
      </div>
    </div>
  )
}
